export enum Messages {
  NO_QUESTION = 'There are no Questions in Survey Sections',
  INVALID_QUESTION = 'Question is Invalid, Please check',
  // CR-213: matches the backend validation message for same-section duplicate questions.
  DUPLICATE_QUESTION = 'Each question must be unique within a section. Please rename or remove the duplicate question.',
}

export enum BranchingOperation {
  Is = 'is',
  IsEmpty = 'unanswered',
  IsNotEmpty = 'answered'
}

export interface IBranchingSurveyItems {
  key: string
  surveySectionName: string
  surveySectionId: string
}

export type ISurveyItemBranchingFilters = IBranchingSurveyItems[] | null

export enum SurveyItemQuestionType {
  DESCRIPTIVE_TEXT = 'Title',
  FREE_RESPONSE = 'FreeResponse',
  LINEAR_SCALE = 'LinearScale',
  MULTIPLE_CHOICE = 'MultipleChoice',
  MULTI_SELECT = 'MultiSelect'
}
export const ItemTypeMappings: Record<string, string> = {
  'Descriptive Text': 'Title',
  'Free Response': 'FreeResponse',
  'Linear Scale': 'LinearScale',
  'Multiple Choice': 'MultipleChoice',
  'Multi-Select': 'MultiSelect'
}

export interface DescriptiveQuestion {
  itemType: string
  itemId?: string
  prompt: string
  object?: string[]
  isRequired: boolean
  branchingFilters: ISurveyItemBranchingFilters
  revision?: number
  isSchoolApproved?: boolean
}

export interface MultiChoiceQuestion {
  itemType: string
  itemId?: string
  prompt: string
  object: string[]
  isRequired: boolean
  branchingFilters: ISurveyItemBranchingFilters
  revision?: number
  isSchoolApproved?: boolean
}

export interface ILinearObject {
  option: string
  weight: number | null
}
export interface LinearQuestion {
  itemType: string
  itemId?: string
  prompt: string
  object: ILinearObject[]
  isRequired: boolean
  branchingFilters: ISurveyItemBranchingFilters
  revision?: number
  isSchoolApproved?: boolean
}

export interface FreeResponseQuestion {
  itemType: string
  itemId?: string
  prompt: string
  object?: string[]
  isRequired?: boolean
  branchingFilters: ISurveyItemBranchingFilters
  revision?: number
  isSchoolApproved?: boolean
}

export type Question = (DescriptiveQuestion | MultiChoiceQuestion | FreeResponseQuestion | LinearQuestion) & {
  isActuallySchoolApproved?: boolean
}
export interface EditableSurveyQuestionItem {
  itemId: string
  itemType: string
  prompt: string
  object?: string[] | ILinearObject[]
}
